import SpeechToken from "../models/SpeechToken";

export async function fetchSpeechToken(): Promise<SpeechToken | null> {
    const response = await fetch('api/webchat/speechServiceAccessToken');
    if (!response.ok) {
      return null;
    }
    const tokenValue = await response.json();
    const tenMinutesInMiliseconds = 10 * 60 * 1000;
    return {token: tokenValue, expiryDate: new Date(Date.now() + tenMinutesInMiliseconds)};
}